// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1_J-g","row":"Node_row__3thxr","label":"Node_label__2Aghq","footer":"Node_footer__1lGrW"};